<script lang="ts">
	import { page } from '$app/stores';
	import { PUBLIC_BLOG_URL } from '$env/static/public';
	import { PUBLIC_IMAGES_API } from '$env/static/public';
	import { supportedLanguages } from '$lib/translations/translations';
	import buildLanguagePath from '$lib/utils/buildLanguagePath';

	const hrefLangs = supportedLanguages.map((lang) => ({
		lang,
		path: $page.url.origin + buildLanguagePath($page.url.pathname, lang)
	}));
</script>

<svelte:head>
	<link rel="dns-prefetch" href={PUBLIC_IMAGES_API} />
	<link rel="dns-prefetch" href={PUBLIC_BLOG_URL} />
	<link
		rel="preload"
		href="https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@100;200;300;400;500;600;700;800;900&display=swap"
	/>
	<link
		rel="stylesheet"
		href="https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@100;200;300;400;500;600;700;800;900&display=swap"
	/>
	{#each hrefLangs as hrefLang}
		<link rel="alternate" hreflang={hrefLang.lang} href={hrefLang.path} />
	{/each}
</svelte:head>

<slot />
